import { useAuditReportsGetGipMetadataVersions } from '@mi-front/api-v2';
import { DateTimeStr } from '@mi-front/core';

/**
 * Versions list for the GIP form via api-v2 audit-reports metadata.
 */
export function useGipVersionsQuery(
  params: {
    from: DateTimeStr;
    to: DateTimeStr;
    stations: string[];
    advertisers: string[];
    campaigns: string[];
  },
  enabled: boolean,
) {
  return useAuditReportsGetGipMetadataVersions(params, {
    query: {
      enabled,
      select: (versions) => versions.filter((v) => !!v),
    },
  });
}
